import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  sub: string;
  id: number;
  email: string;
  roles: string[];
  iat?: number;
  exp?: number;
}

export const runAuthDiagnostics = () => {
  console.group('🔐 Auth Diagnostics');
  
  try {
    // Check stored auth data
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    console.log('1️⃣ Stored Data:');
    console.log('   - Token exists:', !!token);
    console.log('   - User data:', user ? JSON.parse(user) : null);
    
    if (token) {
      console.log('\n2️⃣ JWT Token Analysis:');
      try {
        const decoded: DecodedToken = jwtDecode(token);
        console.log('   - Subject (username):', decoded.sub);
        console.log('   - User ID:', decoded.id);
        console.log('   - Email:', decoded.email);
        console.log('   - Roles:', decoded.roles);
        console.log('   - Issued at:', decoded.iat ? new Date(decoded.iat * 1000).toLocaleString() : 'N/A');
        console.log('   - Expires at:', decoded.exp ? new Date(decoded.exp * 1000).toLocaleString() : 'N/A');
        
        // Check if token is expired
        if (decoded.exp) {
          const isExpired = Date.now() >= decoded.exp * 1000;
          console.log('   - Is expired:', isExpired);
        }
        
        // Compare JWT roles with stored user roles
        if (user) {
          const storedUser = JSON.parse(user);
          console.log('\n3️⃣ Role Comparison:');
          console.log('   - JWT roles:', decoded.roles);
          console.log('   - Stored user roles:', storedUser.roles);
          
          const rolesMatch = JSON.stringify(decoded.roles.sort()) === JSON.stringify(storedUser.roles.sort());
          console.log('   - Roles match:', rolesMatch);
          
          if (!rolesMatch) {
            console.warn('   ⚠️ JWT roles do not match stored user roles!');
          }
        }
      } catch (error) {
        console.error('Failed to decode JWT:', error);
      }
    }
    
    // Check for stale auth state
    console.log('\n4️⃣ Auth State Checks:');
    const guestSession = localStorage.getItem('guestSession');
    console.log('   - Has guest session:', !!guestSession);
    
    if (guestSession) {
      const session = JSON.parse(guestSession);
      console.log('   - Guest session data:', session);
    }
    
    // Provide recommendations
    console.log('\n5️⃣ Recommendations:');
    if (token && user) {
      const decoded: DecodedToken = jwtDecode(token);
      const storedUser = JSON.parse(user);
      
      if (JSON.stringify(decoded.roles.sort()) !== JSON.stringify(storedUser.roles.sort())) {
        console.log('   ⚠️ Clear local storage and re-login to sync roles');
        console.log('   Run: localStorage.clear(); location.reload();');
      }
      
      if (decoded.exp && Date.now() >= decoded.exp * 1000) {
        console.log('   ⚠️ Token is expired, re-login required');
      }
    }
    
  } catch (error) {
    console.error('Error running auth diagnostics:', error);
  } finally {
    console.groupEnd();
  }
};

// Export for console usage
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).runAuthDiagnostics = runAuthDiagnostics;